import { Observable, of, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { Injectable } from '@angular/core';

import { SnCurrentOrganization } from '@lib/auth';
import { FsLprCamerasService } from '@lib/vehicle-intelligence/api';

@Injectable({
  providedIn: 'root',
})
export class LprIntegrationsService {
  private _integrations: string[] = null;
  private readonly _loaded$ = new Subject<void>();

  constructor(
    private readonly _lprCamerasService: FsLprCamerasService,
    private readonly _currentOrganization: SnCurrentOrganization,
  ) {}

  get load$(): Observable<void> {
    return this._loaded$.asObservable();
  }

  get integrations(): string[] {
    return this._integrations;
  }

  public checkLprIntegrations(): Observable<string[]> {
    if (this._integrations === null) {
      const lprApi = localStorage.getItem('LPR_API') ?? '';

      // In some cases the organization settings are not loaded yet,
      // but in such cases we can rely on if the lpr domain is not provided (`lprConfigured`) to avoid loading providers
      const lprEnabled: boolean = this._currentOrganization?.settings?.envEnableLpr ?? true;
      const lprConfigured: boolean = !!lprApi;

      if (!lprEnabled || !lprConfigured) {
        this._integrations = [];
        return of([]);
      }

      return this._lprCamerasService.getProviders().pipe(
        map((response) => {
          this._integrations = response;
          return response;
        }),
      );
    }
    return of(this._integrations);
  }

  public hasIntegration(type: string): boolean {
    if (this._integrations === null) {
      return false;
    }
    return this._integrations.findIndex((integration: any) => integration === type) > -1;
  }

  public getIntegration(type: string): string | any {
    if (this._integrations === null) {
      return false;
    }
    return <string>this._integrations.find((integration: any) => integration === type);
  }

  public handleTypeNames(type: string): string {
    switch (true) {
      case type.toLowerCase() === 'fs alpr':
        return 'Flock';
      case type.toLowerCase() === 'rt alpr':
        return 'Riverland';
      default:
        return type;
    }
  }
}
